import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

const InternalErrorBoundary = ({ children }) => {
  return <SentryErrorBoundary>{children}</SentryErrorBoundary>;
};

InternalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InternalErrorBoundary;
